import { Button, Icon } from '@platform/components';

type BackToOptionsButtonProps = {
  onClick: () => void;
};

export const BackToOptionsButton = (props: BackToOptionsButtonProps) => {
  const { onClick } = props;
  return (
    <div className='w-full flex flex-row justify-center items-center pb-8 md:pb-2'>
      <Button
        size='sm'
        variant='tertiary-color'
        onPress={onClick}
        additionalClassnames='text-sm text-gray-500 font-semibold focus:bg-white active:text-gray-400 flex flex-row hover:bg-white items-center justify-center gap-1 w-[180px] max-w-[180px]'
      >
        <Icon type='arrow-left' size='20' />
        Back to options
      </Button>
    </div>
  );
};
